<template>
  <div class="home-type3-root">
    <main
      id="MainContent"
      class="content-for-layout"
      role="main"
      data-page-transition-enabled="true"
      data-product-transition="true"
      data-template="index"
    >
      <div
        id="shopify-section-template--20801322549474__home_split_hero_Y4iFwr"
        class="shopify-section"
      >
        <!-- 首页头部区块 -->
        <section
          class="hs-wrap hs-scope"
          data-hs-hero=""
          style="padding-top: 14px;"
        >
          <!-- HERO -->
          <PageHeader
            :homeInfo="homeInfo"
            :expertConfig="expertConfig"
            @handleChangeExpert="handleChangeExpert"
          />

          <!-- 最近精选推荐 -->
          <div class="hs-pickups-wrap">
            <div
              class="hs-pickups"
              :aria-label="pageState.pickupsAria"
            >
              <router-link
                class="hs-pill hs-pill--link"
                to="/goods"
                :aria-label="pageState.pickupsPill.ariaLabel"
              >
                {{ pageState.pickupsPill.text }}
              </router-link>

              <div
                class="hs-listwrap"
                aria-hidden="false"
              >
                <div
                  class="hs-list"
                  data-hs-list=""
                  aria-label="Recent pickups carousel"
                  ref="pickupListRef"
                >
                  <span
                    v-for="item in pickupItems"
                    :key="item.id"
                    class="hs-item"
                    @click="handleBuyNow(item)"
                  >
                    <div class="hs-thumb">
                      <img
                        :src="item.goodsImage"
                        :alt="item.goodsName"
                        loading="lazy"
                        class="hs-thumb-img"
                      >
                    </div>
                    <div class="hs-meta">
                      <div class="hs-name">
                        {{ item.goodsName }}
                      </div>
                      <div class="hs-price">
                        {{ item.currencySymbol || '$' }} {{ item.price }}
                      </div>
                    </div>
                    <div
                      class="hs-chev"
                      aria-hidden="true"
                    >
                      ›
                    </div>
                  </span>
                </div>
              </div>

              <div class="hs-stats">
                <div
                  v-for="(row, idx) in pickupStats"
                  :key="`pickup-stat-${idx}`"
                  class="hs-stat"
                >
                  <div class="hs-stat-num">
                    {{ row.num }}
                  </div>
                  <div class="hs-stat-label">
                    {{ row.label }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- 分类区块 -->
      <HomeCollectionList :Categories="homeInfo?.goodsList?.['Categories'] || []" />

      <!-- 商品列表区块 -->
      <div class="shopify-section ui-test-product-list">
        <!-- 商品列表容器 -->
        <div
          data-testid="product-list"
          style="
            max-width: none;
            --padding-block-start: 18px;
            --padding-block-end: 18px;
            --gap: 24px;
          "
          class="
             section
             section--page-width
             color-scheme-1
             section-resource-list
             spacing-style
             gap-style
          "
        >
          <!-- 商品列表头部 -->
          <div class="section-resource-list__header">
            <div
              class=" spacing-style text-block text-block--AV1lSV0tjYmJ6c1Rta__product_list_text_jWLgBb h3      "
              style="--padding-block-start: 0px; --padding-block-end:0px; --padding-inline-start:0px; --padding-inline-end:0px;         --width: fit-content;    --max-width: var(--max-width--body-normal);          "
            >
              <p class="hs-title">
                BEST SELLERS
              </p>
            </div>

            <router-link
              class="bb-shop-all-link"
              to="/goods"
            >
              SHOP ALL →
            </router-link>
          </div>

          <!-- 商品列表内容 -->
          <GoodsList
            :goodsList="homeInfo?.goodsList?.['Best Sellers'] || []"
            :selectPlatform="selectPlatform"
          />

          <div
            class="section-resource-list__content"
            style="--horizontal-alignment: flex-start;"
          >
          </div>
        </div>
      </div>

      <!-- 查看所有商品按钮 -->
      <div
        class="ai-view-all-button-container-aynhczmfttff1ctnhuaigenblocke6c229cylgrnd"
        style="padding-top: 24px;"
      >
        <router-link
          to="/goods"
          class="ai-view-all-button-aynhczmfttff1ctnhuaigenblocke6c229cylgrnd"
        >
          VIEW ALL PRODUCTS
        </router-link>
      </div>

      <!-- 文字走马灯区块 -->
      <div
        id="shopify-section-template--20801322549474__marquee_9AMajF"
        class="shopify-section"
      >
        <div class="section-background color-scheme-5">
        </div>
        <marquee-component
          class="section spacing-style gap-style color-scheme-5"
          style="
          --padding-block-start: max(20px, calc(var(--spacing-scale) * 48px)); 
          --padding-block-end: max(20px, calc(var(--spacing-scale) * 48px));
          --marquee-gap: max(24px, calc(var(--gap-scale, 1.0) * 100px)); 
          --marquee-direction: normal;
          --marquee-speed: 50s;
          max-width: 100%;"
          data-speed-factor="25"
          data-movement-direction="normal"
        >
          <div
            class="marquee__wrapper"
            ref="wrapper"
          >
            <div
              class="marquee__content"
              ref="content"
            >
              <div
                v-for="(item, idx) in pageState.marqueeItems"
                :key="`marquee-main-${idx}`"
                class="marquee__repeated-items"
              >
                <div class=" spacing-style text-block h1">
                  <h1>
                    <router-link
                      class="marquee-link"
                      to="/goods"
                      :title="item.title"
                    >
                      {{ item.text }}
                    </router-link>
                  </h1>
                </div>
              </div>
            </div>
            <div
              class="marquee__content"
              aria-hidden="true"
            >
              <div
                v-for="(item, idx) in pageState.marqueeItems"
                :key="`marquee-ghost-${idx}`"
                class="marquee__repeated-items"
              >
                <div
                  class=" spacing-style text-block text-block--ANHIzTHNYR3VOS3pzd__text_RGxHtE h1    text-block--align-left  "
                  style="    --padding-block-start: 0px; --padding-block-end:0px; --padding-inline-start:0px; --padding-inline-end:0px;         --width: 100%;    --max-width: var(--max-width--body-normal);          --text-align: left;          "
                >
                  <h1>
                    <router-link
                      class="marquee-link"
                      to="/goods"
                      :title="item.title"
                    >
                      {{ item.text }}
                    </router-link>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </marquee-component>
      </div>
    </main>

    <!-- 底部区块 -->
    <!-- <div class="footer-utilities">
      <span class="footer-utilities__text">
        © {{ pageState.footer.copyYr }}
        <a
          :href="pageState.footer.brand.href"
          :title="pageState.footer.brand.title"
        >
          {{ pageState.footer.brand.text }}
        </a>,
        <a
          target="_blank"
          rel="nofollow"
          :href="pageState.footer.powered.href"
        >
          {{ pageState.footer.powered.text }}
        </a>
      </span>

      <button
        class="policy-list-trigger button-unstyled"
        :popovertarget="pageState.footer.policy.popTarget"
        :popovertargetaction="pageState.footer.policy.popAction"
        ref="trigger"
      >
        {{ pageState.footer.policy.text }}
      </button>
    </div> -->
  </div>
</template>

<script>
import PageHeader from './components/page-header.vue'
import HomeCollectionList from './components/home-collection-list.vue'
import GoodsList from './components/goods-list.vue'

export default {
  name: 'HomeType3Content',

  components: {
    PageHeader,
    HomeCollectionList,
    GoodsList
  },

  props: {
    homeInfo: {
      type: Object,
      default: () => ({}),
    },

    expertConfig: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectPlatform: {},
      // 页面状态统一收敛到一个对象，便于后续维护
      pageState: {
        // 最近精选区块：区域无障碍文案
        pickupsAria: 'Recent pickups',
        pickupsPill: {
          text: 'RECENT PICKUPS',
          ariaLabel: 'View My Pickups collection'
        },
      
        marqueeItems: [
          {
            text: 'SHOP NOW',
            title: 'All products'
          },
          {
            text: 'SHOP NOW',
            title: 'All products'
          },
          {
            text: 'SHOP NOW',
            title: 'All products'
          },
          {
            text: 'SHOP NOW',
            title: 'All products'
          }
        ],
        // 页脚：版权年、品牌链接、Powered 链接、政策按钮
        footer: {
          copyYr: '2026',
          brand: {
            href: '#',
            title: '',
            text: "Mr.Aaron's Grails"
          },
          powered: {
            href: '',
            text: 'Powered by Shopify'
          },
          policy: {
            text: 'Terms and Policies',
            popTarget: 'terms-policies-popover',
            popAction: 'toggle'
          }
        }
      }
    }
  },

  computed: {
    pickupItems() {
      return this.homeInfo?.goodsList?.['New Items'] || []
    },

    pickupStats(){
      const num = this.pickupItems.length
      const totalPrice = Number(this.pickupItems.reduce((acc, item) => acc + item.price, 0)).toFixed(2)
      return [
      { num: num, label: 'NEW ITEMS' },
      { num: `$${totalPrice}`, label: 'TOTAL VALUE' }
      ]
    },
  },

  mounted() {
    this.bindPickupMouseDrag()
  },
  beforeDestroy() {
    this.unbindPickupMouseDrag()
  },

  methods: {
    bindPickupMouseDrag() {
      const listEl = this.$refs.pickupListRef
      if (!listEl) return
      this._pickupDrag = {
        dragging: false,
        startX: 0,
        startLeft: 0,
        moved: false,
        blockClick: false
      }
      this._onPickupMouseDown = (event) => this.onPickupMouseDown(event)
      this._onPickupMouseMove = (event) => this.onPickupMouseMove(event)
      this._onPickupMouseUp = () => this.onPickupMouseUp()
      this._onPickupClickCapture = (event) => this.onPickupClickCapture(event)
      listEl.addEventListener('mousedown', this._onPickupMouseDown)
      window.addEventListener('mousemove', this._onPickupMouseMove)
      window.addEventListener('mouseup', this._onPickupMouseUp)
      listEl.addEventListener('click', this._onPickupClickCapture, true)
    },
    unbindPickupMouseDrag() {
      const listEl = this.$refs.pickupListRef
      if (listEl && this._onPickupMouseDown) {
        listEl.removeEventListener('mousedown', this._onPickupMouseDown)
        this._onPickupMouseDown = null
      }
      if (listEl && this._onPickupClickCapture) {
        listEl.removeEventListener('click', this._onPickupClickCapture, true)
        this._onPickupClickCapture = null
      }
      if (this._onPickupMouseMove) {
        window.removeEventListener('mousemove', this._onPickupMouseMove)
        this._onPickupMouseMove = null
      }
      if (this._onPickupMouseUp) {
        window.removeEventListener('mouseup', this._onPickupMouseUp)
        this._onPickupMouseUp = null
      }
      if (this._pickupPrevUserSelect !== undefined) {
        document.body.style.userSelect = this._pickupPrevUserSelect
        this._pickupPrevUserSelect = undefined
      }
    },
    /**
     * 最近精选：鼠标按下进入拖拽模式
     * @param {MouseEvent} event
     */
    onPickupMouseDown(event) {
      if (event.button !== 0) return
      const listEl = this.$refs.pickupListRef
      if (!listEl || !this._pickupDrag) return
      this._pickupDrag.dragging = true
      this._pickupDrag.startX = event.clientX
      this._pickupDrag.startLeft = listEl.scrollLeft
      this._pickupDrag.moved = false
      this._pickupPrevUserSelect = document.body.style.userSelect
      document.body.style.userSelect = 'none'
      listEl.classList.add('is-autoscrolling')
      if (event.cancelable) {
        event.preventDefault()
      }
    },
    /**
     * 最近精选：鼠标移动按位移更新横向滚动
     * @param {MouseEvent} event
     */
    onPickupMouseMove(event) {
      const listEl = this.$refs.pickupListRef
      if (!listEl || !this._pickupDrag || !this._pickupDrag.dragging) return
      const dx = event.clientX - this._pickupDrag.startX
      if (Math.abs(dx) > 4) {
        this._pickupDrag.moved = true
      }
      listEl.scrollLeft = this._pickupDrag.startLeft - dx
      if (event.cancelable) {
        event.preventDefault()
      }
    },
    /**
     * 最近精选：结束鼠标拖拽，恢复选择和滚动状态
     */
    onPickupMouseUp() {
      const listEl = this.$refs.pickupListRef
      if (!listEl || !this._pickupDrag || !this._pickupDrag.dragging) return
      this._pickupDrag.dragging = false
      listEl.classList.remove('is-autoscrolling')
      if (this._pickupPrevUserSelect !== undefined) {
        document.body.style.userSelect = this._pickupPrevUserSelect
        this._pickupPrevUserSelect = undefined
      }
      if (this._pickupDrag.moved) {
        this._pickupDrag.blockClick = true
        window.setTimeout(() => {
          if (this._pickupDrag) {
            this._pickupDrag.blockClick = false
          }
        }, 0)
      }
    },
    /**
     * 拖拽后阻止误触发购买点击
     * @param {MouseEvent} event
     */
    onPickupClickCapture(event) {
      if (!this._pickupDrag || !this._pickupDrag.blockClick) return
      event.preventDefault()
      event.stopPropagation()
    },
    handleChangeExpert(platform) {
      this.selectPlatform = platform;
    },
      	//立即购买
		handleBuyNow(goods) {
			if (!this.selectPlatform.platformId) {
				return this.$message.warning(this.$t('selectPlatform'));
			}
			var url = this.selectPlatform.platformUrl;
			if (url.indexOf('{goodId}') != -1) {
				url = url.replace('{goodId}', goods.weidianGoodsId);
			}
			if (url.indexOf('{weidian}') != -1) {
				url = url.replace('{weidian}', goods.weidianId);
			}
			if (url.indexOf('{inviteCode}') != -1) {
				url = url.replace('{inviteCode}', this.selectPlatform.invitationCode);
			}
			window.open(url);
		}
  }
}

</script>

<style scoped lang="scss">
@import './assets/home-type3-content.scss';

.text-block > .hs-title, .bb-shop-all-link{
  color: var(--primary-color)!important;
}

.hs-pill--link{
border: 1px solid var(--button-color);
background-color: transparent;
color: var(--primary-color)!important;
}

.hs-pill--link:hover{
  color: var(--primary-color)!important;
}

.marquee-link{
  color: #fff!important;
}

.marquee-link:hover{
  color: hsl(from #fff h s l / 0.5)!important;
}

.section-resource-list__header{
  padding: 16px 40px;
}

@media screen and (max-width: 749px) {
  .section-resource-list__header{
    padding: 16px;
  }
}

.section-background {
  background-color: var(--primary-color)!important;
}

</style>